<script lang="ts">
  import Dialog, { Actions, Content } from '@smui/dialog';
  import { onDestroy } from 'svelte';
  import 'bootstrap/js/dist/modal';
  import ExtraButton from '../../common/components/ExtraButton.svelte';
  import Icon from '../../common/components/Icon.svelte';
  import Text from '../../common/components/Text.svelte';
  import { mapProductsToServices, ServiceProduct } from '../mapper/home-maintenance.mapper';
  import { addHomeMaintenanceToCart, closeCityUnavailableError } from '../service/home-maintenance-data-services';
  import {
    cityUnavailable,
    closeHomeMaintenanceDialog,
    currentHomeMaintenanceServiceData,
    hasValidServices,
    resetHomeMaintenanceState,
    showCityUnavailableError,
  } from '../store/home_maintenance_store';
  import HMServiceOptionCard from './HMServiceOptionCard.svelte';
  import { APP_CONSTANTS } from '../../../common/config/app-constants';

  export let open = false;
  // const isResponsive = isMobileWidth();
  let resetKey = 0;

  /* ---------- DERIVED SERVICES ---------- */

  $: services = mapProductsToServices($currentHomeMaintenanceServiceData) as ServiceProduct[];

  /* ---------- CLOSE ---------- */

  function setHtmlOverflow(value: string) {
    if (typeof document !== 'undefined') {
      document.documentElement.style.overflow = value;
    }
  }

  function closeHandler() {
    setHtmlOverflow('');
    closeHomeMaintenanceDialog();
    resetHomeMaintenanceState();
    open = false;
    resetKey++;
  }

  onDestroy(() => {
    setHtmlOverflow('');
  });
</script>

<div class="home-maintenance-dialog">
  <Dialog
    bind:open
    fullscreen
    aria-labelledby="fullscreen-title"
    surface$style="width:100vw;height:100dvh;max-height:100vh"
    aria-describedby="fullscreen-content"
    on:SMUIDialog:opened={() => setHtmlOverflow('hidden')}
    on:SMUIDialog:closed={closeHandler}
    class="extraDrawer-container home-maintenance-dialog home-maintenance-dialog-svelte"
  >
    <Content id="fullscreen-content">
      <div class="dialog-header">
        <span class="primary-title">
          {$currentHomeMaintenanceServiceData?.name}
        </span>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="close-btn" on:click={closeHomeMaintenanceDialog}>
          <Icon type="font" glyph="close" mobileSize={20} desktopSize={30} />
        </div>
      </div>
      {#if $cityUnavailable && $showCityUnavailableError}
        <div class="hm-city-error">
          <span> <Text key="extra.home.service.area.not.available.message" /></span>
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div on:click={closeCityUnavailableError}>
            <Icon type="font" glyph="close" mobileSize={20} desktopSize={20} />
          </div>
        </div>
      {/if}
      <section class="home-maintenance-dialog-content">
        <div class="feature-image">
          <img
            class="img"
            src={`${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}${services[0]?.categoryCode}?fmt=auto&w=1026&h=356&sm=c`}
            alt="Img"
          />
        </div>
        {#key resetKey}
          {#if services.length === 0}
            <p>No services available</p>
          {:else}
            {#each services as service (service.id)}
              <HMServiceOptionCard {service} />
            {/each}
          {/if}
        {/key}
      </section>
    </Content>
    <Actions>
      <div class="c_home-maintenance-popup-btns-block {!$hasValidServices || $cityUnavailable ? 'disabled' : ''}">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="c_home-maintenance-popup-btns" on:click={() => addHomeMaintenanceToCart()}>
          <ExtraButton
            color="secondary"
            size="medium"
            disabled={!$hasValidServices || $cityUnavailable}
            variant="solid"
          >
            <Text key="extra.home.service.add.selected.service" />
          </ExtraButton>
        </div>
      </div>
    </Actions>
  </Dialog>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  :global {
    .home-maintenance-dialog-svelte {
      .mdc-dialog__surface {
        padding: 0 48px;
        @include desktop-max-width {
          padding: 8px;
        }
        .mdc-dialog__content {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .dialog-header {
          align-items: center;
          display: flex;
          justify-content: space-between;
          padding: 44px 0 16px 0;
          .primary-title {
            color: $neutral-dark-01;
            font-weight: 700;
            font-size: 24px;
            line-height: 28px;
          }
          .close-btn {
            cursor: pointer;
            color: $tertiary-blue-02;
          }
        }
        .home-maintenance-dialog-content {
          display: flex;
          flex-direction: column;
          border: 1px solid $neutral-light-04;
          padding: 8px;
          gap: 8px;
          border-radius: 16px;
          background-color: $neutral-light-04;
          margin-bottom: 72px;
          .feature-image {
            img {
              // max-height: 178px;
              border-radius: 16px;
              // width: -webkit-fill-available;
            }
          }
        }
      }
      .c_home-maintenance-popup-btns-block {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: center;
        &.disabled {
          pointer-events: none;
        }
      }

      .hm-city-error {
        display: flex;
        align-items: center;
        gap: 8px;
        background-color: #fffdf6;
        color: $black;
        border-radius: 8px;
        padding: 12px 16px;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        border: 1px solid $functional-yellow;
        justify-content: space-between;
        .c_icon_new {
          color: $functional-yellow;
        }
      }
    }
  }
</style>
